<!--
    功能：校区认证
-->
<template>
  <div :class="['auth', from]">
    <div class="form_box">
      <div class="title">认证</div>
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        class="form"
        label-width="220px">
        <el-row >
          <el-col :span="24">
            <el-form-item
              label="机构名称："
              prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入机构名称"/>
            </el-form-item>
            <el-form-item label="品牌名称：">
              <el-input
                v-model="form.brand"
                placeholder="请输入品牌名称"/>
            </el-form-item>
            <el-form-item
              label="品牌logo："
              class="logo">
              <AppUploadScale
                v-model="form.logo"
                :icon="true"
                :is-h5="from === 'h5'"
                class="form_img"
                @on-success="getThumbnailrUrl" />
            </el-form-item>
            <el-form-item
              label="主营类目："
              prop="school_categories">
              <el-select
                v-model="form.school_categories"
                multiple
                clearable
                popper-class="auth_select"
                placeholder="请选择类目">
                <el-option
                  v-for="item in category"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"/>
              </el-select>
            </el-form-item>
            <el-form-item
              label="所在地区："
              prop="province">
              <el-cascader
                :popper-class="from === 'h5' ? 'auth_cascader' : ''"
                v-model="places"
                :options="chinaJSON"
                placeholder="请选择所在地区"
                @change="handleChange"/>
              <el-input
                v-model="form.street"
                class="address"
                placeholder="请输入详细地址"/>
            </el-form-item>
            <!--            <el-form-item label="校长名称：" prop="user_name">-->
            <!--              <el-input v-model="form.user_name" placeholder="请输入校长姓名"></el-input>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="校长电话：" prop="user_mobile">-->
            <!--              <el-input v-model="form.user_mobile" disabled="disabled" placeholder="请输入校长电话"></el-input>-->
            <!--            </el-form-item>-->
            <el-form-item label="邮箱：">
              <el-input
                v-model="form.email"
                placeholder="请输入邮箱地址"/>
            </el-form-item>
            <el-form-item label="公司全称：">
              <el-input
                v-model="form.company_name"
                placeholder="请输入公司全称"/>
            </el-form-item>
            <el-form-item label="统一社会代码：">
              <el-input
                v-model="form.company_code"
                placeholder="请输入统一社会代码"/>
            </el-form-item>
            <el-form-item label="营业执照上传：">
              <AppUploadScale
                v-model="form.company_license_img"
                :icon="true"
                :is-h5="from === 'h5'"
                class="company_img"
                @on-success="getThumbnailrUrlCompany" />
            </el-form-item>
            <div class="tips">
              <div class="left"/>
              <div class="right">
                <p>注：请上传营业执照（统一社会信用代码证等）照片，照片务 必清晰完整。图片格式支持“jpg.”、“png.”,图片大小不超 过5MB。 身份证照仅作为资质审核用途，我们会保证您的证件信息安全， 绝不用于任何其他用途，请您放心上传！</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="agreement">
        <input
          id="check"
          ref="check"
          class="agreement_check"
          type="checkbox">
        <label for="check"/>
        我已阅读并同意<a
          href="https://www.yunkedun.com/ykd_agreement.html"
          target="_blank">《在线课堂协议》</a>
      </div>
      <el-button
        class="submit_btn"
        type="primary"
        @click="onSubmit">认证</el-button>
    </div>
  </div>
</template>

<script>
import baseUrl from '../utils/api';

export default {
  name: 'Auth',
  data() {
    return {
      places: [],
      form: {
        name: '', // 校区名称
        brand: '', // 品牌名称
        logo: '', // 品牌logo
        school_categories: [], // 所属类目
        province: '', // 所在省
        city: '', // 所在市
        area: '', // 所在区
        street: '', // 所在街道等详细地址
        // user_name: '', // 校长名称
        // user_mobile: '', // 校长电话
        email: '', // 邮箱
        company_name: '', // 公司全称
        company_code: '', // 统一社会信用代码
        company_license_img: '', // 营业执照图片url
        is_customer_and_clients: 1, // 是否为来自官网认证
      },
      rules: {
        name: [
          { required: true, message: '请输入机构', trigger: 'blur' },
        ],
        brand: [
          { required: true, message: '品牌名称不能为空', trigger: 'blur' },
        ],
        school_categories: [
          { required: true, message: '请选择类目' },
        ],
        province: [
          { required: true, message: '请选择地区' },
        ],
        // user_name: [
        //   { required: true, message: '请输入校长名称', trigger: 'blur' },
        // ],
        // user_mobile: [
        //   this.$rules.required('校长电话'), { ...this.$rules.mobile }
        // ],
        company_name: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
        ],
        company_code: [
          { required: true, message: '请输入社会统一代码', trigger: 'blur' },
        ],
        company_license_img: [
          { required: true, message: '请上传营业执照', trigger: 'blur' },
        ],
      },
      chinaJSON: this.$assets.chinaJSON,
      isCreated: true,
      from: this.$route.query.from || null,
      source: this.$route.query.source || null,
      category: this.$store.state.schoolCategory,
    };
  },
  // computed: {
  //   category() { // 校区类目
  //     return this.$store.state.schoolCategory;
  //   }
  // },
  created() {
    this.from = this.$setting.core();
  },
  methods: {
    // 选择地址
    handleChange(val) {
      const province = val[0] ? this.chinaJSON.find(item => item.value === val[0]) : ''; // 所在省
      const city = val[1] ? province.children.find(item => item.value === val[1]) : ''; // 所在市
      const area = val[2] ? city.children.find(item => item.value === val[2]) : ''; // 所在区
      this.form.province = province.label;
      this.form.city = city.label;
      this.form.area = area.label;
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.isCreated) {
            if (this.$refs.check.checked) {
              // 机构认证
              this.isCreated = false;
              this.$http.post(`${baseUrl}/api/customer`, this.form)
                .then((res) => {
                  this.isCreated = true;
                  this.$confirm('提交成功，点击确定返回主页', '提示', {
                    confirmButtonText: '确定',
                    customClass: this.source === 'school' ? 'auth_dialog_box' : this.from === 'h5' ? 'auth_dialog_box_device' : '',
                    showClose: false,
                    showCancelButton: false,
                    distinguishCancelAndClose: true,
                    closeOnPressEscape: false,
                    closeOnClickModal: false,
                    type: 'warning',
                  }).then(() => {
                    window.parent.postMessage(
                      { type: 'success', data: 'success' },
                      '*',
                    );
                    if (this.source === 'school') {
                      window.location.href = `${baseUrl}/sso/logout?client_id=4&redirect_uri=${this.$domain.schoolManagement}&response_type=token&scope=&state=4`;
                    }
                    // setTimeout(() => {
                    //   window.open(`${baseUrl}/oauth/authorize?client_id=4&redirect_uri=${this.$domain.schoolManagement}&response_type=token&scope=&state=auto`);
                    // }, 500)
                    // setTimeout(() => {
                    //   this.$router.back();
                    // }, 1000)
                  });
                })
                .catch((err) => {
                  this.isCreated = true;
                  this.$message({
                    message: err.message,
                    type: 'error',
                    customClass: 'auth_dialog_box_message',
                  });
                });
            } else {
              this.isCreated = true;
              this.$alert('请先勾选在线课堂协议！', '提示', {
                confirmButtonText: '确定',
                customClass: 'auth_dialog_box',
                callback: () => {},
              });
            }
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getThumbnailrUrl(url) {
      this.$nextTick(() => {
        this.form.logo = url;
      });
      this.$forceUpdate();
    },
    getThumbnailrUrlCompany(url) {
      this.$nextTick(() => {
        this.form.company_license_img = url;
      });
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped lang="scss">
  .auth {
    margin: 70px auto 0;
    width: 712px;
    border-radius: 10px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    padding: 50px 0;
    .title {
      text-align: center;
      font-size: 36px;
      color: #FFC000;
      margin-bottom: 50px;
    }
    .form {
      padding-right: 100px;
    }
    .submit_btn {
      display: block;
      width: 273px;
      height: 55px;
      border-radius: 10px;
      margin: 30px auto 0;
      font-size: 24px;
    }
    .agreement {
      text-align: center;
      font-size: 18px;
      color: #979797;
      a {
        color: #979797;
        text-decoration: none;
        &:hover {
          color: #FFC000;
        }
      }
      input {
        width: auto;
        height: auto;
        display: none;
      }
      label {
        display: inline-block;
        vertical-align: middle;
        width: 22px;
        height: 22px;
        position: relative;
        cursor: pointer;
        &:before {
          display: block;
          content: ' ';
          position: absolute;
          left: 0;
          top: 0;
          border: 1px solid #dcdfe6;
          border-radius: 2px;
          box-sizing: border-box;
          width: 22px;
          height: 22px;
          background-color: #fff;
          z-index: 1;
        }
        &:after {
          box-sizing: content-box;
          content: " ";
          border: 1px solid #fff;
          border-left: 0;
          border-top: 0;
          height: 13px;
          left: 8px;
          position: absolute;
          top: 2px;
          transform: rotate(45deg) scaleY(0);
          width: 5px;
          transition: transform .15s ease-in .05s;
          transform-origin: center;
          z-index: 10;
        }
      }
      input:checked + label {
        &:before {
          background: #FBAD15;
          border: #FBAD15;
        }
        &:after {
          transform: rotate(45deg) scaleY(1);
        }
      }
    }
  }
  .address {
    width: calc(100% - 205px);
  }
  .el-select {
    width: 100%;
  }
  .form_img {
    width: 140px;
    height: 140px;
    & >>> img {
      width: 100% !important;
      height: 100% !important;
    }
  }
  .company_img {
    width: 391px;
    height: 187px;
    & >>> img {
      width: 100% !important;
      height: 100% !important;
    }
  }
  .image {
    width: 100%;
    height: 100%;
  }
  .logo {
    margin-bottom: 9px;
  }
  .company {
    .el-input {
      margin-bottom: 22px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .tips{
    display: flex;
    font-size: 14px;
    color: #A6A6A6;
    margin-bottom: 20px;
    .left {
      flex: 0 0 220px;
      text-align: right;
      line-height: 20px;
    }
    .right {
      p {
        margin: 0;
        line-height: 20px;
      }
    }
  }
  .auth.h5 {
    width: 100vw;
    margin: 0;
    border-radius: 0;
    box-shadow: 0 0 0 #fff;
    .title {
      font-size: 8vw;
    }
    .form {
      width: 100%;
      box-sizing: border-box;
      padding: 0 5vw;
      .el-form-item {
        margin-bottom: 5vw;
      }
      /deep/
      .el-form-item__label {
        display: block;
        width: 31vw !important;
        font-size: 3.5vw;
        line-height: 10vw;
      }
      /deep/
      .el-form-item__content {
        margin-left: 31vw !important;
      }
      /deep/
      .el-input__inner {
        height: 10vw;
        line-height: 10vw;
        font-size: 3.5vw;
      }
      /deep/
      .el-cascader {
        margin-bottom: 3vw;
        display: block;
      }
      /deep/
      .el-form-item__error {
        font-size: 3vw;
      }
      .company_img {
        width: 50vw;
        height: 25vw;
      }
      .tips {
        display: block;
        .left{
          display: none;
        }
        .right {
          p {
            font-size: 3vw;
            line-height: 5vw;
          }
        }
      }
    }
    .address {
      width: 100%;
    }
    .agreement {
      text-align: center;
      font-size: 3vw;
      color: #979797;
      a {
        color: #979797;
        text-decoration: none;
        &:hover {
          color: #FFC000;
        }
      }
      input {
        width: auto;
        height: auto;
        display: none;
      }
      label {
        display: inline-block;
        vertical-align: middle;
        width: 3vw;
        height: 3vw;
        position: relative;
        cursor: pointer;
        &:before {
          display: block;
          content: ' ';
          position: absolute;
          left: 0;
          top: 0;
          border: 1px solid #dcdfe6;
          border-radius: 2px;
          box-sizing: border-box;
          width: 3vw;
          height: 3vw;
          background-color: #fff;
          z-index: 1;
        }
        &:after {
          box-sizing: content-box;
          content: " ";
          border: 1px solid #fff;
          border-left: 0;
          border-top: 0;
          height: 2vw;
          left: 1.3vw;
          position: absolute;
          top: 2px;
          transform: rotate(45deg) scaleY(0);
          width: 5px;
          transition: transform .15s ease-in .05s;
          transform-origin: center;
          z-index: 10;
        }
      }
      input:checked + label {
        &:before {
          background: #FBAD15;
          border: #FBAD15;
        }
        &:after {
          transform: rotate(45deg) scaleY(1);
        }
      }
    }
    .submit_btn {
      width: 40vw;
      height: 10vw;
      line-height: 10vw;
      font-size: 3vw;
      box-sizing: border-box;
      padding: 0;
      /deep/
      span {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/Auth.vue